import { IModalAction, IModalDescription } from 'models/modal';
import { IStore } from 'redux/IStore';

/** Action Types */
export const MODAL_OPEN: string = 'modal/MODAL_OPEN';
export const MODAL_CLOSE: string = 'modal/MODAL_CLOSE';

/** Counter: Initial State */
const initialState: IModalDescription[] = [];

// Should exist on Array type but does not
const findLastIndex = (arr, cmp) => {
	for (let i = arr.length - 1; i >= 0; i--) {
		if (cmp(arr[i])) return arr[i];
	}
	return -1;
};

/** Reducer */
export function modalReducer(state = initialState, action: IModalAction) {
	switch (action.type) {
		case MODAL_OPEN:
			document.body.style.overflow = 'hidden';
			return state.concat(action.payload);

		case MODAL_CLOSE:
			const newState = state.slice();

			if (action?.payload?.modalType) {
				const modalToRemove = findLastIndex(
					newState,
					(modalPayload: IModalDescription) => modalPayload.modalType == action?.payload?.modalType,
				);
				if (modalToRemove == -1) {
					newState.pop();
				} else {
					newState.splice(modalToRemove, 1);
				}
			} else {
				newState.pop();
			}

			if (!newState?.length) {
				document.body.style.overflow = '';
			}
			return newState;
		default:
			return state;
	}
}

/**
 * Close the top modal
 * @param modalType if provided, close the top modal of type modalType
 * @returns
 */
export function closeModal(modalType?: string): IModalAction {
	return {
		type: MODAL_CLOSE,
		payload: {
			modalType,
		},
	};
}

export function showModal(modalType: string, modalProps: any): IModalAction {
	return {
		type: MODAL_OPEN,
		payload: {
			modalType,
			modalProps,
		},
	};
}

/** Action Creator */
export function isModalOpened(modalType: string) {
	return (_, getState: () => IStore) => {
		const modals: IModalDescription[] = getState().modals;
		if (modals.find((x) => x.modalType === modalType)) {
			return true;
		} else {
			return false;
		}
	};
}
